<template>
	<div class="message-item">
		
		<div :class="{'receiver' : value.answerby == '', 'sender' : value.answerby != '', 'bot' : value.answerby == 'bot'}">
			<div class="user">
				<template v-if="!isReceiver">
					<img class="profile" :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture'" alt="" style="width:30px; height: 30px">
					<img class="small_bot" src="/static/img/assets/livechat/small_robot.png" alt="">
				</template>
				<template v-else>
					<template v-if="receiver.profile_pic">
						<img class="profile" :src="receiver.profile_pic" alt="" style="width:30px; height: 30px">
					</template>
				</template>
			</div>
			<div class="message">
				<div class="text" v-if="value.messagetype == 'text'">{{ value.messagedata }}</div>
				<div class="text" v-else>{{ value.messagedata }}</div>
			</div>

			<div class="clearfix"></div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default{
	props: ['value','receiver'],
	data: function() {
		return {
			message: this.value
		}
	},
	computed: {
	    ...mapGetters({
	        selectedBot: 'selectedBot'
	    }),
		isReceiver: function (){
			// sender == admin and bot
			// receiver == customer
			return this.value.answerby == ''
		}
	},
}
	
</script>


// WEBPACK FOOTER //
// src/components/view/livechat/livechat-message.vue